import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const RemoveParentConfirmatoryPopupWrapper = styled.div`
  .confirmatory-message {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
`;

export const CreateClientWrapper = styled.div`
  color: ${COLORS.cirrus_black};
  .MuiAccordionSummary-root {
    padding: 0px;
    margin: 0px;
    padding-right: 28px;
  }

  .separator-space {
    margin: 24px 0px;

    ${responsive.MOBILE`
     margin: 16px 8px;
    `}
  }

  .Mui-expanded {
    .MuiAccordionSummary-root {
      margin: 0px;
      background: ${COLORS.primary_light_blue2};
    }
  }
  .MuiAccordionSummary-root {
    background: ${COLORS.primary_light_blue2};
  }

  .MuiAccordionSummary-content {
    margin: 0px;
  }

  .accordion-expanded {
  }
  .header-collapse {
    padding-right: 28px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .container-bottom {
    padding: 32px 16px 20px 0px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: ${COLORS.cirrus_white};
    ${responsive.MOBILE`
       margin-bottom: 0px;
       padding: 0px 8px 16px 8px !important;
       padding-right: 0px;
       justify-content: center;
       flex-direction: column-reverse;
       margin-top:  0px;
    `}
  }
  .bottom-button-clear {
    ${responsive.MOBILE`
      width: 100%;
      margin-left: 0px;
      margin-top:16px;
    `}
  }
  .bottom-button-continue {
    margin-left: 16px;
    ${responsive.MOBILE`
      width: 100%;
      margin-left: 0px;
      margin-top:16px;
    `}
  }
`;
